export default __webpack_public_path__ + "static/media/And.59014bd5.svg";